import { FieldValues, Path, UseFormSetError } from "react-hook-form";
import { toast } from "sonner";
import { ApiError } from "../api/http";

interface ValidationError {
    field: string;
    message: string;
}

/**
 * Handles API errors from form submissions.
 *
 * - 400/422 with `{ errors: [{ field, message }] }` → maps to react-hook-form field errors
 * - All other errors → falls back to a toast notification
 */
export function handleApiFormError<T extends FieldValues>(
    error: unknown,
    setError: UseFormSetError<T>,
): void {
    if (error instanceof ApiError && (error.status === 400 || error.status === 422)) {
        const body = error.details as { errors?: ValidationError[] } | undefined;
        const fieldErrors = body?.errors;

        if (fieldErrors && fieldErrors.length > 0) {
            for (const { field, message } of fieldErrors) {
                setError(field as Path<T>, { type: "server", message });
            }
            return;
        }
    }

    const message =
        error instanceof ApiError
            ? error.message
            : error instanceof Error
              ? error.message
              : "Something went wrong. Please try again.";

    toast.error(message);
}
